import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { adminAuthApi } from '@ct-vision/shared';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'Layout',
      component: () => import('@/components/layout/AdminLayout.vue'),
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/DashboardView.vue'),
        },
        {
          path: 'admins',
          name: 'AdminList',
          component: () => import('@/views/AdminListView.vue'),
        },
        {
          path: 'users',
          name: 'UserList',
          component: () => import('@/views/UserListView.vue'),
        },
        {
          path: 'online-users',
          name: 'OnlineUsers',
          component: () => import('@/views/OnlineUsersView.vue'),
        },
        {
          path: 'finance/orders',
          name: 'FinanceOrders',
          component: () => import('@/views/FinanceOrdersView.vue'),
        },
        {
          path: 'finance/expenses',
          name: 'FinanceExpenses',
          component: () => import('@/views/FinanceExpensesView.vue'),
        },
        {
          path: 'tasks',
          name: 'TaskMonitor',
          component: () => import('@/views/TaskMonitorView.vue'),
        },
        {
          path: 'prompts',
          name: 'PromptTemplates',
          component: () => import('@/views/PromptTemplatesView.vue'),
        },
        {
          path: 'prompts/:parentId/children',
          name: 'prompt-template-children',
          component: () => import('@/views/PromptTemplateChildrenView.vue'),
        },
        {
          path: 'platform-adaptation-rules',
          name: 'PlatformAdaptationRules',
          component: () => import('@/views/PlatformAdaptationRulesView.vue'),
        },
        {
          path: 'ai-models',
          name: 'AiModels',
          component: () => import('@/views/AiModelsView.vue'),
        },
        {
          path: 'image-usages',
          name: 'ImageUsages',
          component: () => import('@/views/ImageUsagesView.vue'),
        },
        {
          path: 'settings',
          name: 'SystemSettings',
          component: () => import('@/views/SystemSettingsView.vue'),
        },
        {
          path: 'audit-logs',
          name: 'AuditLogs',
          component: () => import('@/views/AuditLogsView.vue'),
        },
      ],
    },
  ],
});

// 记录 token 是否已验证过（每次应用启动只验证一次）
let tokenVerified = false;

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // 如果有 token 但还没验证过，调用后端接口验证 token 有效性
  if (authStore.isAuthenticated && !tokenVerified) {
    try {
      const admin = await adminAuthApi.getCurrentAdmin();
      authStore.admin = admin;
      tokenVerified = true;
    } catch {
      // token 无效或过期，清除认证状态
      authStore.clearAuth();
      tokenVerified = true;
    }
  }

  if (!to.meta.public && !authStore.isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

export default router;
